import { useRef, useState } from "react";
import { Upload, CheckCircle2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadFile, errMsg } from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";
import { t } from "@/i18n";

export const FileUpload = ({ kind, accept, label, value, filename, onUploaded, onClear, testId, compact }) => {
  const ref = useRef();
  const [progress, setProgress] = useState(null);

  const handle = async (file) => {
    if (!file) return;
    setProgress(0);
    try {
      const rec = await uploadFile(file, kind, setProgress);
      onUploaded(rec);
      if (rec.resized) {
        const [w, h] = rec.original_dimensions || [];
        toast.success(t("{f} subido", { f: file.name }), { description: t("La portada venía en {w}×{h}; se ajustó automáticamente a 3000×3000 px (JPG).", { w, h }) });
      } else {
        toast.success(t("{f} subido", { f: file.name }));
      }
    } catch (e) {
      toast.error(errMsg(e, t("No se pudo subir el archivo")));
    } finally {
      setProgress(null);
    }
  };

  return (
    <div data-testid={testId} className={cn("rounded-md border border-dashed border-border bg-secondary/40 transition-colors hover:border-primary/60", compact ? "p-3" : "p-5")}
      onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); handle(e.dataTransfer.files?.[0]); }}>
      <input ref={ref} type="file" accept={accept} className="hidden" data-testid={`${testId}-input`} onChange={(e) => handle(e.target.files?.[0])} />
      {progress !== null ? (
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">{t("Subiendo… {p}%", { p: progress })}</p>
          <Progress value={progress} className="h-1.5" />
        </div>
      ) : value ? (
        <div className="flex items-center gap-3">
          <CheckCircle2 className="h-4 w-4 text-primary shrink-0" />
          <span className="text-sm truncate flex-1" data-testid={`${testId}-filename`}>{filename || t("Archivo cargado")}</span>
          <button type="button" onClick={() => ref.current.click()} className="text-xs text-primary hover:underline">{t("Reemplazar")}</button>
          {onClear && <button type="button" onClick={onClear} data-testid={`${testId}-clear`} className="text-muted-foreground hover:text-destructive"><X className="h-4 w-4" /></button>}
        </div>
      ) : (
        <button type="button" onClick={() => ref.current.click()} className="w-full flex items-center gap-3 text-left">
          <div className="h-9 w-9 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0"><Upload className="h-4 w-4" /></div>
          <div>
            <p className="text-sm font-medium">{label}</p>
            <p className="text-xs text-muted-foreground">{t("Arrastra o haz clic")} · {accept}</p>
          </div>
        </button>
      )}
    </div>
  );
};
